import { render, staticRenderFns } from "./mobile-change.vue?vue&type=template&id=c0660a56&scoped=true&"
import script from "./mobile-change.vue?vue&type=script&lang=js&"
export * from "./mobile-change.vue?vue&type=script&lang=js&"
import style0 from "./mobile-change.vue?vue&type=style&index=0&id=c0660a56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0660a56",
  null
  
)

export default component.exports